import {Directive, forwardRef, Inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {isValidVat, Vat, VatFormatter} from '@atlas/businesstypes';

import {
  ATLAS_VALUE_ACCESSOR,
  AtlasControlValueAccessor,
  BaseBusinesstypeDirective,
} from '../base/index';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasVat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => VatDirective),
    },
  ],
})
export class VatDirective extends BaseBusinesstypeDirective {
  public constructor(@Inject(ATLAS_VALUE_ACCESSOR) input: AtlasControlValueAccessor) {
    super(input);
  }

  public writeValue(value?: Vat | string): void {
    this._input.writeValue(
      Vat.isVat(value) ? VatFormatter.format(value) : value == null ? '' : value,
    );
  }

  public registerOnChange(fn: (_: Vat | string | null) => void): void {
    this._input.registerOnChange(value => {
      if (value === '') {
        fn(null);
        return;
      }

      const unformatted = VatFormatter.unformat(value);
      fn(isValidVat(unformatted) ? new Vat(unformatted) : unformatted);
    });
  }
}
